import ReactGA from 'react-ga';


export class Logger {

  static init() {
    if(process.env.REACT_APP_MODE == "production" && process.env.REACT_APP_GOOGLE_ANALYTICS_TAG != null){
      ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_TAG, {
          debug: false
      });
    } 
  }

  static pageview(){
    if(process.env.REACT_APP_MODE == "production" && process.env.REACT_APP_GOOGLE_ANALYTICS_TAG != null){
      ReactGA.pageview(window.location.pathname + window.location.search);
    }else{
      console.log(window.location.pathname + window.location.search);
    }
  }

  static event(event){
    if( event == null ){ return; }
    if(process.env.REACT_APP_MODE == "production" && process.env.REACT_APP_GOOGLE_ANALYTICS_TAG != null){
      ReactGA.event(event);
    }else{
      console.log(event);
    }
  }
}